export default __webpack_public_path__ + "static/media/35.93a1e457.png";